import {
  WalletPayableSummaryItemResponse,
  WalletPayablesSummaryResponse,
} from "../../../domain/models/accounting/wallet-payables.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isString = (value: unknown): value is string => typeof value === "string";

const isNullableString = (value: unknown): value is string | null =>
  value === null || isString(value);

const isItem = (value: unknown): value is WalletPayableSummaryItemResponse =>
  isRecord(value) &&
  isFiniteNumber(value["idConcept"]) &&
  isString(value["conceptName"]) &&
  isFiniteNumber(value["amount"]) &&
  isFiniteNumber(value["paidAmount"]) &&
  isNullableString(value["paymentDate"]) &&
  isFiniteNumber(value["idPaymentStatus"]) &&
  isString(value["paymentStatus"]) &&
  isString(value["paymentStatusName"]);

export function isWalletPayablesSummaryResponse(
  value: unknown,
): value is WalletPayablesSummaryResponse {
  return isRecord(value) &&
    isFiniteNumber(value["idCompany"]) &&
    isFiniteNumber(value["idPeriod"]) &&
    isFiniteNumber(value["idCurrency"]) &&
    isFiniteNumber(value["totalAmount"]) &&
    isString(value["updatedAt"]) &&
    Array.isArray(value["items"]) &&
    value["items"].every(isItem) &&
    isFiniteNumber(value["limit"]) &&
    isFiniteNumber(value["offset"]) &&
    typeof value["hasNext"] === "boolean";
}
